import React, { useEffect, useRef, useState } from 'react';

import {
  PillDropdown,
  PillDropdownInner,
  PillDropdownItem,
  PillDropdownLabel,
  PillModalDropdownBody,
  PillDropdownThumb,
  PillDropdownText,
  PillDropdownScrollArea,
  PillScrollbarThumb,
  PillScrollbarTrack,
} from '../AskAIPageStyles';
import secondaryCourseCardDummy from '../../../assets/images/secondaryCourseCardDummy.jpg';

const COURSE_ITEMS = [
  {
    id: 1,
    title: 'How to spread the digital word: Communications strategy',
    image: secondaryCourseCardDummy,
  },
  {
    id: 2,
    title: 'How to spread the digital word: Communications strategy',
    image: secondaryCourseCardDummy,
  },
  {
    id: 3,
    title: 'How to spread the digital word: Communications strategy',
    image: secondaryCourseCardDummy,
  },
  {
    id: 4,
    title: 'How to spread the digital word: Communications strategy',
    image: secondaryCourseCardDummy,
  },
];

const CourseDropdown = ({ variant = 'dropdown' }) => {
  const scrollRef = useRef(null);
  const [thumbStyle, setThumbStyle] = useState({
    top: 0,
    height: 0,
    visible: false,
  });

  const updateThumb = () => {
    const element = scrollRef.current;

    if (!element) {
      return;
    }

    const { scrollTop, scrollHeight, clientHeight } = element;

    if (scrollHeight <= clientHeight) {
      setThumbStyle({ top: 0, height: 0, visible: false });
      return;
    }

    const minThumbHeight = 36;
    const computedHeight = Math.max(
      minThumbHeight,
      (clientHeight / scrollHeight) * clientHeight,
    );
    const maxTop = clientHeight - computedHeight;
    const computedTop = (scrollTop / (scrollHeight - clientHeight)) * maxTop;

    setThumbStyle({
      top: computedTop,
      height: computedHeight,
      visible: true,
    });
  };

  useEffect(() => {
    updateThumb();
    window.addEventListener('resize', updateThumb);

    return () => {
      window.removeEventListener('resize', updateThumb);
    };
  }, []);

  const content = (
    <>
      <PillDropdownScrollArea
        ref={scrollRef}
        onScroll={updateThumb}
        onMouseEnter={updateThumb}
      >
        {COURSE_ITEMS.map((item) => (
          <PillDropdownItem key={item.id}>
            <PillDropdownThumb src={item.image} alt="Course thumbnail" />
            <PillDropdownText>
              <PillDropdownLabel className='vds-micro'>Course</PillDropdownLabel>
              <a className='vds-body-sm' href='#'>{item.title}</a>
            </PillDropdownText>
          </PillDropdownItem>
        ))}
      </PillDropdownScrollArea>
      {thumbStyle.visible && (
        <PillScrollbarTrack>
          <PillScrollbarThumb
            style={{
              top: `${thumbStyle.top}px`,
              height: `${thumbStyle.height}px`,
            }}
          />
        </PillScrollbarTrack>
      )}
    </>
  );

  if (variant === 'modal') {
    return <PillModalDropdownBody>{content}</PillModalDropdownBody>;
  }

  return (
    <PillDropdown>
      <PillDropdownInner>
        {content}
      </PillDropdownInner>
    </PillDropdown>
  );
};

export default CourseDropdown;
